import React from 'react';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import DateTimePicker from 'react-datetime-picker';

import Util from '../../util/Util';

class ColdDateFilter extends React.Component {
  static conditionOptions = [
    { value: 'between',     label: 'Between'     },
    { value: 'not-between', label: 'Not Between' },
    { value: 'today',       label: 'Today'       },
    { value: 'yesterday',   label: 'Yesterday'   },
    { value: 'tomorrow',    label: 'Tomorrow'    },
    { value: 'this-month',  label: 'This Month'  },
    { value: 'last-month',  label: 'Last Month'  },
    { value: 'next-month',  label: 'Next Month'  },
    { value: 'last-7-days', label: 'Last 7 Days' },
    { value: 'next-7-days', label: 'Next 7 Days' },
  ];

  constructor(props) {
    super(props);
    const f = props.filter;
    const condition = f
      ? ColdDateFilter.conditionOptions.find(c => c.value === f.condition) || null
      : ColdDateFilter.conditionOptions[0];
    this.state = { condition, from: null, to: null };
  }

  componentDidUpdate(prevProps) {
    // Reset child state when parent clears filters
    if (prevProps.filter && !this.props.filter) {
      this.setState({ condition: null, from: null, to: null });
    }
  }

  onConditionChanged = select => {
    this.setState({ condition: select, from: null, to: null });

    const isRange = select.value === 'between' || select.value === 'not-between';
    if (!isRange) {
      // Preset shortcut — resolve to a date range value immediately
      const value = ColdDateFilter.getValue(select.value);
      this.props.onValueChange(this.props.field.field_key, select.value, value);
    } else {
      // Range selected but no dates yet — remove filter until both dates picked
      // this.props.deleteFilter(this.props.field.field_key);
    }
  };

  onDateChange = (date, source) => {
    const next = { ...this.state, [source]: date };
    this.setState(next);

    if (next.from && next.to) {
      const from = new Date(next.from);
      from.setHours(0, 0, 0, 0);
      const to = new Date(next.to);
      to.setHours(23, 59, 59, 999);
      const value = Util.dateToServerDateTime(from) + '~' + Util.dateToServerDateTime(to);
      this.props.onValueChange(this.props.field.field_key, next.condition.value, value);
    }
  };

  onReset = () => {
    this.setState({ condition: null, from: null, to: null });
    this.props.resetFilter(this.props.field.field_key);
  };

  render() {
    const { field } = this.props;
    const { condition, from, to } = this.state;
    const isRange  = condition && (condition.value === 'between' || condition.value === 'not-between');
    const isActive = condition !== null;

    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">{field.label_name}</p>
          </div>
          <div className={`col-md-${isActive ? 5 : 7}`}>
            <Select
              value={condition}
              onChange={this.onConditionChanged}
              options={ColdDateFilter.conditionOptions}
              isSearchable={true}
              placeholder="Select..."
            />
          </div>
          {isActive && (
            <div className="col-md-1">
              <FaTimes style={{ cursor: 'pointer' }} onClick={this.onReset} />
            </div>
          )}
        </div>

        {isRange && (
          <div className="row pt-2">
            <div className="col-md-12">
              <DateTimePicker
                onChange={date => this.onDateChange(date, 'from')}
                value={from}
                format="dd-MM-y"
              />
            </div>
            <div className="col-md-12 mt-1">
              <DateTimePicker
                onChange={date => this.onDateChange(date, 'to')}
                value={to}
                format="dd-MM-y"
              />
            </div>
          </div>
        )}
        <hr />
      </>
    );
  }

  static getValue = value => {
    const d = new Date();
    const fmt = date => Util.dateToServerDateTime(date);
    const range = (from, to) => fmt(from) + '~' + fmt(to);

    const startOf  = date => { date.setHours(0,  0,  0,  0);   return date; };
    const endOf    = date => { date.setHours(23, 59, 59, 999);  return date; };
    const clone    = ()    => new Date();

    switch (value) {
      case 'today':
        return range(startOf(clone()), endOf(clone()));

      case 'yesterday': {
        const y = clone(); y.setDate(y.getDate() - 1);
        return range(startOf(y), endOf(new Date(y)));
      }

      case 'tomorrow': {
        const t = clone(); t.setDate(t.getDate() + 1);
        return range(startOf(t), endOf(new Date(t)));
      }

      case 'this-month': {
        const s = clone(); s.setDate(1);
        const e = new Date(s.getFullYear(), s.getMonth() + 1, 0);
        return range(startOf(s), endOf(e));
      }

      case 'last-month': {
        const s = clone(); s.setMonth(s.getMonth() - 1); s.setDate(1);
        const e = new Date(s.getFullYear(), s.getMonth() + 1, 0);
        return range(startOf(s), endOf(e));
      }

      case 'next-month': {
        const s = clone(); s.setMonth(s.getMonth() + 1); s.setDate(1);
        const e = new Date(s.getFullYear(), s.getMonth() + 1, 0);
        return range(startOf(s), endOf(e));
      }

      case 'last-7-days': {
        const s = clone(); s.setDate(s.getDate() - 7);
        return range(startOf(s), endOf(clone()));
      }

      case 'next-7-days': {
        const s = clone(); s.setDate(s.getDate() + 1);
        const e = clone(); e.setDate(e.getDate() + 7);
        return range(startOf(s), endOf(e));
      }

      default:
        return '';
    }
  };
}

export default ColdDateFilter;